import React from 'react';
import { Helmet } from 'react-helmet';

// Expects an array of `{ title: string, id: string }`
const TableOfContents = ({ sections = [] }) => {
  if (!sections || sections.length === 0) return null;

  const firstUrl = sections.length > 0
    ? `https://zapexpenses.com/mtd-2026-guide#${sections[0].id}`
    : "https://zapexpenses.com/mtd-2026-guide";

  // Generate ItemList and SiteNavigationElement Schema
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ItemList",
        "name": "Contents of MTD 2026 Master Guide",
        "itemListElement": sections.map((sec, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": sec.title,
          "url": `https://zapexpenses.com/mtd-2026-guide#${sec.id}`
        }))
      },
      {
        "@type": "SiteNavigationElement",
        "name": "Topic Cluster Table of Contents",
        "url": firstUrl
      }
    ]
  };

  return (
    <div className="w-full max-w-sm mb-12 hidden md:block lg:float-right lg:ml-10 lg:mb-10 lg:sticky lg:top-8 z-10">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>

      <div className="bg-slate-900/80 backdrop-blur-md border border-slate-700/50 rounded-2xl p-6 shadow-2xl">
        <div className="flex items-start justify-between mb-4">
          <h4 className="text-white font-extrabold tracking-tight text-lg">Topical Map</h4>
        </div>

        <nav aria-label="Table of contents">
          <ul className="space-y-3">
            {sections.map((sec, index) => (
              <li key={index}>
                <a
                  href={`#${sec.id}`}
                  className="text-slate-300 hover:text-indigo-400 text-sm font-medium transition-colors flex gap-2 group"
                >
                  <span className="text-slate-600 font-mono text-xs mt-0.5 group-hover:text-indigo-500">{index + 1}.</span>
                  {sec.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default TableOfContents;
